//#region Dependencias
import config from "../config";
import React, { Component } from 'react';
import '../css/dataTables.css';
import '../css/responsive.css';
import $ from 'jquery';
import ApiClient from '../libs/apiClient';
import SuggestionList from './SuggestionList';
import ItemsCreateModal from './ItemsCreateModal';
import { SERVICE_RESPONSE } from '../libs/utils/Const';
import { InventoryCounter, InventoryCountingLine, InventoryPosting, InventoryPostingLine } from './NewOrder';
import AlmacenModal from './AlmacenModal';
import StandardSelectModal from './StandardSelectModal';
import MultipleCountersModal from './MultipleCountersModal';
import moment from "moment";
import SeriesCreateModal from "./SeriesCreateModal";
//#endregion

//#region Variables globales
const apiClient = ApiClient.getInstance();

const binHeaders = [
    { title: "Código de ubicación", value: true, filter: true, field: "BinCode", format: null, classes: "text-left" },
];

const usersHeaders = [
    { title: "Usuario", value: true, filter: true, field: "UserName", format: null, classes: "text-left" },
    { title: "Departamento", value: true, filter: true, field: "Department", format: null, classes: "text-left" },
    { title: "Sucursal", value: true, filter: true, field: "Branch", format: null, classes: "text-left" },
    { title: "Código de usuario", value: false, filter: true, field: "UserCode", format: null, classes: "text-left" },
];

const employeesHeaders = [
    { title: "Apellido", value: true, filter: true, field: "lastName", format: null, classes: "text-left" },
    { title: "Nombre", value: true, filter: true, field: "firstName", format: null, classes: "text-left" },
    { title: "Código", value: false, filter: true, field: "Code", format: null, classes: "text-left" },
];

const FORMAT_NUMBER = (num, decimals = 2) => {
    if (isNaN(num)) return (0).toFixed(decimals);

    num = Number(num).toFixed(decimals);
    let splitStr = num.split(".");
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? '.' + splitStr[1] : "";
    let regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
        splitLeft = splitLeft.replace(regx, "$1" + ',' + "$2");
    }
    return splitLeft + splitRight;
};
const dateFormat = (date) => { return moment(date).format("YYYY-MM-DD"); }
const timeFormat = (time) => { return Number(time) > 999 ? `${time.toString().substring(0, 2)}:${time.toString().substring(2)}` : `0${time.toString().substring(0, 1)}:${time.toString().substring(1)}`; }
//#endregion

class InventoryCountingCreateModal extends Component {
    //#region Acciones del componente
    constructor(props) {
        super(props);
        this.state = {
            //#region Variables de control
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            editMode: false,
            itemSearch: "",
            itemToUpdate: -1,
            action: 2,
            //#endregion

            //#region Modales de selección
            showItemsModal: false,
            itemsResults: [],
            itemsPageTotal: 0,

            showBinModal: false,
            binsResults: [],

            showMultipleCountersModal: false,
            multipleCounters: [],
            selectionType: -1,
            multipleCountersType: "",

            showCountersModal: false,
            countersResults: [],
            countersModalHeaders: null,

            showWarehouseModal: false,
            warehouses: [],
            //#endregion

            //#region Lista de sugerencias
            showUsersSuggestion: false,
            usersSuggestions: [],

            showEmployeesSuggestion: false,
            employeesSuggestions: [],

            showItemsSuggestion: false,
            itemsSuggestions: [],

            showWarehouseSuggestion: false,
            warehouseSuggestions: [],

            indexItemCode: -1,
            //#endregion

            series: [],
        };
    }

    componentDidMount = async () => {
        const { action } = this.props;
        await this.setState({ action });
    }

    updateSuggestionsPosition = (container = "", input = "", list = "", paddingTop = 0, paddingLeft = 0) => {
        const modalElement = document.getElementById(container);

        const inputField = document.getElementById(input);
        const suggestionsList = document.getElementById(list);

        if (!!inputField && !!suggestionsList) {
            if (!!modalElement) {
                const inputRect = inputField.getBoundingClientRect();
                const modalReact = modalElement.getBoundingClientRect();

                suggestionsList.style.top = `${inputRect.top - modalReact.top - inputRect.height - paddingTop}px`;
                suggestionsList.style.left = `${inputRect.left - modalReact.left - paddingLeft}px`;
            } else if (!!suggestionsList) {
                suggestionsList.style.top = `calc(60%)`;
                suggestionsList.style.left = `calc(25%)`;
            }
        }
    }
    //#endregion

    //#region Crear documento
    validateModel = async () => {
        const { model, showAlert, createDocument } = this.props;
        if (!model.Series) { return showAlert({ type: "warning", message: "Selecciona una serie valida para continuar" }); }

        if (model.ObjectType === "1470000065") {
            if ((!model.SingleCounterID || model.SingleCounterID === undefined || model.SingleCounterID === "")
                && Number(model.CountingType) === 1) { return showAlert({ type: "warning", message: "Selecciona un encargado de recuento" }); }

            if (model.InventoryCountingLines.length === 0) { return showAlert({ type: "warning", message: "No se han agregado artículos al recuento de inventario" }); }

            for (let i = 0; i < model.InventoryCountingLines.length; i++) {
                let currentLine = model.InventoryCountingLines[i];

                if (!currentLine.WarehouseCode || currentLine.WarehouseCode === undefined || currentLine.WarehouseCode === "") { return showAlert({ type: "warning", message: `No se ha seleccionado un almacén para el articulo '${currentLine.ItemCode}'. Linea ${i + 1}` }); }
                if ((!currentLine.BinCode || currentLine.BinCode === undefined || currentLine.BinCode === "")
                    && currentLine.UseLocations) { return showAlert({ type: "warning", message: `No se ha seleccionado una ubicación para el articulo '${currentLine.ItemCode}'. Linea ${i + 1}` }); }
            }
        } else if (model.ObjectType === '10000071') {
            if (model.InventoryPostingLines.length === 0) { return showAlert({ type: "warning", message: "No se han agregado artículos" }); }

            for (let i = 0; i < model.InventoryPostingLines.length; i++) {
                let currentLine = model.InventoryPostingLines[i];

                if (!currentLine.WarehouseCode || currentLine.WarehouseCode === undefined || currentLine.WarehouseCode === "") { return showAlert({ type: "warning", message: `No se ha seleccionado un almacén para el articulo '${currentLine.ItemCode}'. Linea ${i + 1}` }); }
            }
        }

        await createDocument();
    }

    selectTo = async () => {
        const { enableSpinner, showAlert, updateModel } = this.props;
        const model = { ...this.props.model };
        let newModel = new InventoryPosting();
        
        let dataSerie = {
            docType: newModel.ObjectType,
            docSubType: '--'
        };

        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let ValidateSeries = Array.isArray(seriesResponse?.data)? (seriesResponse.data.filter(({ ObjectCode }) => ObjectCode === newModel.ObjectType)) : [];
        let seriesUsers = user?.U_FMB_ValidateSeriesOIQR;

        if (!user || !ValidateSeries.length || !seriesUsers) {
            return showAlert({ type: 'warning', message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador", timeOut: 5000 });
        }

        seriesUsers = seriesUsers.split("|");

        let newArraySeries = [];

        for (let index = 0; index < seriesUsers.length; index++) {
            const serieUser = seriesUsers[index];
            for (let index = 0; index < ValidateSeries.length; index++) {
                const serieResponse = ValidateSeries[index];
                if (serieResponse.Series.toString() === serieUser.toString()) {
                    newArraySeries.push(serieResponse);
                }
            }
        }

        if (newArraySeries.length === 0) {
            return showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
        }

        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";

        for (let index = 0; index < newArraySeries.length; index++) {
            const serie = newArraySeries[index];
            if (serie.Series.toString() === newArraySeries[0].DfltSeries.toString()) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        }

        newModel.SerieArray = newArraySeries || [];
        newModel.Series = defaultcode;
        newModel.SeriesName = defaultName;
        newModel.DocumentNumber = nextNumber;
        newModel.PostingDate = dateFormat(new Date());
        newModel.CountDate = dateFormat(new Date());
        newModel.CountTime = timeFormat(moment(new Date()).format("HHmm"));

        for(const item of model.InventoryCountingLines) {
            const warehouse = item.WarehousesStocks.find(({ WhsCode }) => WhsCode === item.WarehouseCode);
            let newItem = new InventoryPostingLine();

            newItem.BaseEntry = item.DocumentEntry;
            newItem.BaseLine = item.LineNumber;
            newItem.BaseType = model.ObjectType;
            newItem.CountDate = model.CountDate;
            newItem.CountTime = model.CountTime;

            newItem.ItemCode = item.ItemCode;
            newItem.ItemDescription = item.ItemDescription;
            newItem.WarehouseCode = item.WarehouseCode;
            newItem.PrevWarehouseCode = item.PrevWarehouseCode;
            newItem.InWarehouseQuantity = item.InWarehouseQuantity;
            newItem.CountedQuantity = item.CountedQuantity;
            newItem.AvgPrice = item.AvgPrice;
            newItem.LstEvlPric = item.LstEvlPric;
            newItem.WarehousesStocks = item.WarehousesStocks;
            newItem.PricesList = item.PricesList;
            
            newItem.Variance = item.Variance;
            newItem.VariancePercentage = item.VariancePercentage;

            newItem.Price = Number(Number(newModel.PriceSource) === 1 ? (newItem.PricesList.find(pricelist => Number(pricelist?.PriceList || -10) === Number(newModel.PriceList))?.Price || 0)
                                    : (Number(newModel.PriceSource) === 2 ? (newItem.LstEvlPric) : (Number(newItem.AvgPrice) || Number(warehouse.AvgPrice) || 0))).toFixed(2);
            newItem.Total = Number(Number(newItem.Variance) * Number(newItem.Price)).toFixed(2);
            newModel.InventoryPostingLines.push(newItem);
        }

        updateModel(newModel);
        await this.setState({ action: 1 });
    }
    //#endregion

    //#region Actualizar campos
    //#region Cabecera
    selectCounter = async (value) => {
        let model = { ...this.props.model };

        if (Number(model.CountingType) === 1) {
            const { updateModel } = this.props;

            if (Number(model.SingleCounterType) === 12) {
                model.SingleCounterID = value.UserID;
                model.SingleCounterName = value.UserName;
            } else {
                model.SingleCounterID = value.Code;
                model.SingleCounterName = value.firstName;
            }

            updateModel(model);
        } else {
            const { multipleCounters } = this.state;
            let newCounter = new InventoryCounter();
            if (value.UserID) {
                newCounter.CounterType = 12;
                newCounter.CounterID = value.UserID;
                newCounter.CounterName = value.UserName;
            } else {
                newCounter.CounterType = 171;
                newCounter.CounterID = value.Code;
                newCounter.CounterName = value.firstName;
            }

            multipleCounters.push(newCounter);
        }
        $("#selectSingleCounterModal").modal("hide");
    }

    removeCounter = async (index) => {
        const { multipleCounters } = this.state;
        if (multipleCounters.length > 1) { multipleCounters.splice(index, 1); }
        await this.setState({ multipleCounters });
    }

    saveCounters = async () => {
        const { multipleCounters, selectionType } = this.state;
        const { updateModel } = this.props;
        let model = { ...this.props.model };

        if (selectionType === 1) {
            model.IndividualCounters = multipleCounters;
            model.IndividualCountersQty = multipleCounters.length;
            for (let i = 0; i < model.InventoryCountingLines.length; i++) {
                let line = model.InventoryCountingLines[i];
                line.IndividualCounters = multipleCounters;
            }
        } else {
            model.TeamCounters = multipleCounters;
            model.TeamCountersQty = multipleCounters.length;
        }

        updateModel(model);
        $("#multipleCountersModal").modal("hide");
    }

    changeStandardField = (field, value) => {
        const { updateModel } = this.props;
        let model = { ...this.props.model };
        model[field] = value;
        if (field === "SingleCounterType") {
            if (Number(value) === 12) {
                const { _user, usersList } = this.props;
                const currentUser = usersList.find(({UserID}) => Number(UserID) === Number(_user.USERID)) || {};
                model.SingleCounterID = currentUser.UserID || -1;
                model.SingleCounterName = currentUser.UserName || "";
            } else {
                model.SingleCounterID = -1;
                model.SingleCounterName = "";
            }
        } else if (field === "PriceSource") {
            for (let line of model.InventoryPostingLines) {
                let price = 0;
                if (Number(value) === 1) {
                    price = Array.isArray(line?.PricesList) ? (line.PricesList.find(({ PriceList }) => Number(model.PriceList) === Number(PriceList))?.Price || 0) : 0;
                } else if (Number(value) === 2) {
                    price = line.LstEvlPric || 0;
                } else {
                    const warehouseAvgPrice = (Array.isArray(line.WarehousesStocks) ? (line.WarehousesStocks.find(({ WhsCode }) => WhsCode === line.WarehouseCode)?.AvgPrice || 0) : 0);
                    price = Number(line.AvgPrice) || Number(warehouseAvgPrice) || 0;
                }
                line.Price = Number(price).toFixed(2);
                line.Total = Number(Number(line.Price) * Number(line.Variance)).toFixed(2);
            }
        } else if (field === "PriceList") {
            for (let line of model.InventoryPostingLines) {
                line.Price = Number(Array.isArray(line?.PricesList) ? line.PricesList.find(({ PriceList }) => Number(value) === Number(PriceList))?.Price : 0).toFixed(2);
                line.Total = Number(Number(line.Price) * Number(line.Variance)).toFixed(2);
            }
        }
        updateModel(model);
    }

    openSeries = async () => {
        const { model, showAlert } = this.props;
        if ((model?.SerieArray?.length || 0) === 0) {
            return showAlert({ type: 'info', message: 'No hay Información por mostrar' });
        }

        await this.setState({ series: model.SerieArray });
        $('#seriesDocumentsModal').modal('show');
        $('#seriesDocumentsModal').on('hidden.bs.modal', async () => {
            this.setState({ series: [] })
        });
    };

    selectSeries = (action) => {
        const { updateModel } = this.props;
        let model = { ...this.props.model };
        let serie = model.SerieArray[action.index];
        model.SeriesName = serie.SeriesName || '';
        model.Series = serie.Series || '';
        model.DocumentNumber = serie.NextNumber || '';

        updateModel(model);
        $('#seriesDocumentsModal').modal('hide');
    };
    //#endregion

    //#region Lineas
    selectItems = async (items) => {
        const { updateModel } = this.props;
        const { _user } = this.state;
        const defaultWhs = _user?.DefaultWhs || _user?.Branch?.ProjectCode || "";
        let model = JSON.parse(JSON.stringify(this.props.model));

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const warehouse = item.wareHouses.find(({ WhsCode }) => WhsCode === defaultWhs);
            let newItem = null;

            if (model.ObjectType === '1470000065') { newItem = new InventoryCountingLine(); }
            else if (model.ObjectType === '10000071') { newItem = new InventoryPostingLine(); }

            newItem.ItemCode = item.ItemCode;
            newItem.ItemDescription = item.ItemName;
            newItem.WarehouseCode = defaultWhs;
            newItem.PrevWarehouseCode = defaultWhs;
            newItem.InWarehouseQuantity = Number(warehouse.OnHand || 0).toFixed(3);
            newItem.AvgPrice = item.AvgPrice || 0;
            newItem.LstEvlPric = item.LstEvlPric || 0;
            newItem.WarehousesStocks = item.wareHouses || [];
            newItem.PricesList = item.itemPrice || [];

            if (model.ObjectType === '1470000065') {
                newItem.IndividualCounters = model.IndividualCounters.slice();
                model.InventoryCountingLines.push(newItem);
            } else if (model.ObjectType === '10000071') {
                newItem.CountDate = dateFormat(new Date());
                newItem.CountTime = timeFormat(moment(new Date()).format("HHmm"));
                newItem.Variance = Number(-newItem.InWarehouseQuantity).toFixed(3);
                newItem.VariancePercentage = Math.abs(Number(newItem.InWarehouseQuantity) ? (newItem.Variance / newItem.InWarehouseQuantity * 100) : 0).toFixed(4);
                newItem.Price = Number(Number(model.PriceSource) === 1 ? (newItem.PricesList.find(pricelist => Number(pricelist?.PriceList || -10) === Number(model.PriceList))?.Price || 0)
                                        : (Number(model.PriceSource) === 2 ? (newItem.LstEvlPric) : (Number(newItem.AvgPrice) || Number(warehouse.AvgPrice) || 0))).toFixed(2);
                newItem.Total = Number(Number(newItem.Variance) * Number(newItem.Price)).toFixed(2);
                model.InventoryPostingLines.push(newItem);
            }
        }

        await this.setState({ itemSearch: "" });
        $("#itemsCreate").modal("hide");
        updateModel(model);
    }

    deleteItem = async (index) => {
        const { updateModel } = this.props;
        let model = { ...this.props.model };
        if (model.ObjectType === '1470000065') {
            model.InventoryCountingLines.splice(index, 1);
        } else if (model.ObjectType === '10000071') {
            model.InventoryPostingLines.splice(index, 1);
        }
        await updateModel(model);
    }

    changeStandardFieldLine = (field, index, value) => {
        const { updateModel } = this.props;
        let model = { ...this.props.model };
        let line = null;
        if (model.ObjectType === '1470000065') { line = model.InventoryCountingLines[index]; }
        else if (model.ObjectType === '10000071') { line = model.InventoryPostingLines[index]; }

        line[field] = value;
        
        if (field === "WarehouseCode") {
            line.BinEntry = "";
            line.BinCode = "";
            line.CountedQuantity = "0.000";
            line.UseLocations = false;
        } else if (field === "BinCode") {
            line.BinEntry = "";
            line.CountedQuantity = "0.000";
        }

        updateModel(model);
    }

    changeCheckboxStatus = (index, field, value) => {
        const { updateModel } = this.props;
        let model = { ...this.props.model };
        let line = model.InventoryCountingLines[index];

        line[field] = value ? "Y" : "N";
        if (field === "Counted") { line = this.changeVariance(line, value); }

        updateModel(model);
    }

    changeCountedQty = (index, value) => {
        if (!isNaN(value) || value === "" || value === ".") {
            if (!isNaN(value) && Number(value) < 0) { return; }
            const { updateModel } = this.props;
            let model = { ...this.props.model };

            if (model.ObjectType === '1470000065') { model.InventoryCountingLines[index].CountedQuantity = value; }
            else if (model.ObjectType === '10000071') { model.InventoryPostingLines[index].CountedQuantity = value; }

            updateModel(model);
        }
    }

    changeMultipleCountedQty = (indexLine, indexCounter, value) => {
        if (!isNaN(value) || value === "" || value === ".") {
            if (!isNaN(value) && Number(value) < 0) { return; }
            const { updateModel } = this.props;
            let model = { ...this.props.model };
            let line = model.InventoryCountingLines[indexLine];
            line.IndividualCounters[indexCounter].CountedQuantity = value;
            updateModel(model);
        }
    }
 
    validateCountedQty = (index, value) => {
        const { updateModel } = this.props;
        let model = { ...this.props.model };
        let line = null;
        if (model.ObjectType === '1470000065') { line = model.InventoryCountingLines[index]; }
        else if (model.ObjectType === '10000071') { line = model.InventoryPostingLines[index]; }

        let countQty = 0;

        if (!isNaN(value)) { countQty = Number(value); }
        line.CountedQuantity = countQty.toFixed(3);

        if (model.ObjectType === '1470000065' && line.PrevCountedQty !== countQty) {
            line.PrevCountedQty = countQty;
            line.Counted = "Y";
        }

        line = this.changeVariance(line, line.Counted === "Y");
        updateModel(model);
    }
 
    validateMultipleCountedQty = (indexLine, indexCounter, value) => {
        const { updateModel } = this.props;
        let model = { ...this.props.model };
        let line = model.InventoryCountingLines[indexLine];
        let invCounter = line.IndividualCounters[indexCounter];

        let countQty = 0;

        if (!isNaN(value)) { countQty = Number(value); }
        invCounter.CountedQuantity = countQty.toFixed(3);

        if (Number(invCounter.PrevCountedQty) !== countQty) {
            invCounter.PrevCountedQty = countQty;
            line.Counted = "Y";
        }

        line = this.changeVariance(line, line.Counted === "Y");
        updateModel(model);
    }

    validateWarehouse = async (index, value = "") => {
        let model = { ...this.props.model };
        let line = null;

        if (model.ObjectType === '1470000065') { line = model.InventoryCountingLines[index]; }
        else if (model.ObjectType === '10000071') { line = model.InventoryPostingLines[index]; }

        if (value !== "" && (value !== line.PrevWarehouseCode || !line.UseLocations)) {
            const warehouse = line.WarehousesStocks.findIndex(({WhsCode}) => WhsCode.toLowerCase() === value.toLowerCase());
            if (warehouse !== -1) {
                await this.setState({
                    warehouses: line.WarehousesStocks,
                    itemToUpdate: index
                });
                await this.changeStandardFieldLine("PrevWarehouseCode", index, value);
                await this.selectWarehouse({index: warehouse});
            }
        }
    }

    changeVariance = (line = {}, counted = false) => {
        const { model } = this.props;
        const inWhsQty = Number(line.InWarehouseQuantity || 0);
        const countedQty = Number(line.CountedQuantity || 0);

        let diff = 0;
        let diffPercent = 0;

        if (model.ObjectType === '1470000065' && counted) {
            if (model.CountingType === 1) { diff = countedQty - inWhsQty; }
            else {
                const maxAbsoluteValueObject = line.IndividualCounters.reduce((maxObject, currentObject) => {
                    const currentValue = Math.abs(currentObject.CountedQuantity - inWhsQty);
                    const maxValue = Math.abs(maxObject.CountedQuantity - inWhsQty);
                    if (currentValue > maxValue) { return currentObject; }
                    else { return maxObject; }
                  }, line.IndividualCounters[0]); // Regresa la información del contador más alejado de inWhsQty

                  diff = maxAbsoluteValueObject.CountedQuantity - inWhsQty;
            }
            
            diffPercent = diff !== 0 ? (inWhsQty > 0 ? Math.abs(diff / inWhsQty * 100) : 100) : 0;
        } else if (model.ObjectType === '10000071') {
            diff = countedQty - inWhsQty;
            diffPercent = diff !== 0 ? (inWhsQty > 0 ? Math.abs(diff / inWhsQty * 100) : 100) : 0;
            line.Total = Number(Number(line.Price) * Number(diff)).toFixed(2);
        }

        line.Variance = diff.toFixed(3);
        line.VariancePercentage = diffPercent.toFixed(3);

        return line;
    }

    selectWarehouse = async action => {
        const { warehouses, itemToUpdate } = this.state;
        const { updateModel } = this.props;
        let model = { ...this.props.model };
        let line = null;

        if (model.ObjectType === '1470000065') { line = model.InventoryCountingLines[itemToUpdate]; }
        else if (model.ObjectType === '10000071') { line = model.InventoryPostingLines[itemToUpdate]; }

        const warehouse = warehouses[action.index];

        line.WarehouseCode = warehouse.WhsCode;
        line.CountedQuantity = "0.000";
        line.InWarehouseQuantity = Number(warehouse.OnHand || 0).toFixed(3);
        line.Variance = Number(-line.InWarehouseQuantity).toFixed(3);
        line.VariancePercentage = Math.abs(Number(line.InWarehouseQuantity) ? (line.Variance / line.InWarehouseQuantity * 100) : 0).toFixed(4);
        line.Price = Number(Number(model.PriceSource) === 1 ? (line.PricesList.find(pricelist => Number(pricelist?.PriceList || -10) === Number(model.PriceList))?.Price || 0)
                                : (Number(model.PriceSource) === 2 ? (line.LstEvlPric) : (Number(line.AvgPrice) || Number(warehouse.AvgPrice) || 0))).toFixed(2);
        line.Total = Number(Number(line.Variance) * Number(line.Price)).toFixed(2);

        updateModel(model);
        $('#almacenDocumentsModal').modal('hide');
    }

    selectBinCode = async (value) => {
        const { itemToUpdate } = this.state;
        const { updateModel, showAlert, enableSpinner } = this.props;
        enableSpinner(true);
        let model = { ...this.props.model };
        let line = model.InventoryCountingLines[itemToUpdate];

        const data = {
            itemCode: line.ItemCode || '',
            whsCode: line.WarehouseCode || '',
            binEntry: value.AbsEntry || -1,
        }

        const validateLocation = model.InventoryCountingLines.find((invLine) => invLine.ItemCode === data.itemCode && invLine.WarehouseCode === data.whsCode && Number(invLine.BinEntry) === Number(data.binEntry));

        if (!!validateLocation) {
            showAlert({ type: 'error', message: "La ubicación seleccionada ya se encuentra en el documento actual" });
            enableSpinner(false);
            return;
        }

        const locationStock = await apiClient.locationStock(data)

        if (locationStock.status === SERVICE_RESPONSE.ERROR) {
            showAlert({ type: 'error', message: locationStock.message });
            enableSpinner(false);
            return;
        }

        line.BinEntry = value.AbsEntry;
        line.BinCode = value.BinCode;
        line.CountedQuantity = "0.000";
        line.InWarehouseQuantity = Number(locationStock.data.OnHandQty || 0).toFixed(3);

        showAlert({ type: 'info', message: locationStock.message });
        updateModel(model);
        enableSpinner(false);
        $("#selectBinModal").modal("hide");
    }

    copyQuantities = async () => {
        const { updateModel } = this.props;
        let model = JSON.parse(JSON.stringify(this.props.model));
        let lines = model.InventoryCountingLines || [];

        for (let i = 0; i < lines.length; i++) {
            let currentLine = lines[i];
            currentLine.Counted = "Y";
            currentLine.Variance = "0.000";
            currentLine.VariancePercentage = "0.000";
            if (Number(model.CountingType) === 1) {
                currentLine.CountedQuantity = Number(currentLine.InWarehouseQuantity || "0").toFixed(3);
            } else {
                let individualCounters = currentLine.IndividualCounters || [];
                for (let j = 0; j < individualCounters.length; j++) {
                    let currentCounter = individualCounters[j];
                    currentCounter.CountedQuantity = Number(currentLine.InWarehouseQuantity || "0").toFixed(3);
                }
            }
        }
        updateModel(model);
    }
    //#region Código del artículo
    changeSearchItem = async (itemSearch = '') => {
        if (itemSearch.trim().length > 0) { await this.predictItems(itemSearch.toLowerCase()) }
        else {
            this.setState({
                indexItemCode: -1,
                itemsSuggestions: [],
                showItemsSuggestion: false,
            })
        }
        this.setState({ itemSearch })
        await this.updateSuggestionsPosition("InventoryCountingCreateModal-content", "itemDocumentSearch", "itemsListInventory", 0, 16);
    }

    async predictItems(input) {
        const { itemsList } = this.props;

        if (input !== '' && input !== null && input !== undefined) {
            let searchTokens = input.split(" ");
            const itemsSuggestions = itemsList.filter(record => {
                let tokens = (record?.ItemCode + " " + record?.SWW + " " + record?.ItemName + " " + record?.ItmsGrpCod + " " + record?.ItmsGrpNam).toLowerCase().split(" ");

                let match = searchTokens.every(function (token) {
                    return tokens.some(function (itemToken) {
                        return itemToken.includes(token);
                    });
                });

                return match;
            }).slice(0, 15).map(record => {
                return {
                    value1: record.ItemCode,
                    value2: record.SWW,
                    value3: record.ItemName,
                };
            });

            this.setState({
                indexItemCode: -1,
                itemsSuggestions,
                showItemsSuggestion: itemsSuggestions.length > 0 ? true : false,
            })
        } else {
            this.setState({
                indexItemCode: -1,
                itemsSuggestions: [],
                showItemsSuggestion: false,
            })
        }
    }

    ItemCodeInteractions = (event = null) => {
        const { itemsSuggestions, itemSearch } = this.state;
        let { indexItemCode } = this.state;

        switch(event?.key) {
            case "Enter":
                if (indexItemCode < 0) {
                    if (itemsSuggestions.length === 1) { this.openSelectItem(itemsSuggestions[0].value1) }
                    else { this.openSelectItem(itemSearch); } 
                } else { this.openSelectItem(itemsSuggestions[indexItemCode].value1) }
            break;
            case "ArrowUp":
                if (itemsSuggestions?.length && indexItemCode > -1) { indexItemCode--; }
                this.setState({ indexItemCode });
            break;
            case "ArrowDown": 
                if (itemsSuggestions?.length && indexItemCode < (itemsSuggestions?.length || 0) - 1) { indexItemCode++; }
                this.setState({ indexItemCode });
            break;
            case "Tab":
                if (indexItemCode !== -1 && itemsSuggestions?.length) { 
                    this.openSelectItem(itemsSuggestions[indexItemCode].value1)
                    event.preventDefault();
                } else if (itemsSuggestions?.length === 1) {
                    this.openSelectItem(itemsSuggestions[0].value1)
                    event.preventDefault();
                }
            break;
            default: break;
        }
    }
    //#endregion
    //#endregion
    //#endregion

    //#region Consultar datos
    openSelectCounter = async (counterType) => {
        const { usersList, employeesList } = this.props;
        await this.setState({
            showCountersModal: true,
            countersResults: Number(counterType) === 12 ? usersList : employeesList,
            countersModalHeaders: Number(counterType) === 12 ? usersHeaders : employeesHeaders,
        });
        $("#selectSingleCounterModal").modal("show");
        $("#selectSingleCounterModal").on("hidden.bs.modal", async () => {
            await this.setState({
                showCountersModal: false,
                countersResults: [],
                countersModalHeaders: null,
            });
        });
    }

    openSelectItem = async (itemSearch) => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);

        this.setState({
            indexItemCode: -1,
            itemsSuggestions: [],
            showItemsSuggestion: false,
        })

        let getItemResponse = await apiClient.getItem(null, 'transfers', itemSearch);

        if (getItemResponse.status === SERVICE_RESPONSE.ERROR) {
            enableSpinner(false);
            return showAlert({ type: 'error', message: `Ocurrio un error: ${getItemResponse.message}` });
        }

        if (!getItemResponse.data.results) {
            if (getItemResponse.data.length === 0) {
                enableSpinner(false);
                return showAlert({ type: 'info', message: `No se encontraron resultados` });
            }
        } else if (getItemResponse.data.results.length === 0) {
            enableSpinner(false);
            return showAlert({ type: 'info', message: `No se encontraron resultados` });
        }

        if (getItemResponse.data.length === 1) {
            this.selectItems(getItemResponse.data);
        } else {
            await this.setState({
                showItemsModal: true,
                itemsResults: getItemResponse.data.results,
                itemsPageTotal: getItemResponse.data.totalPage
            });
            $("#itemsCreate").modal("show");
            $("#itemsCreate").on("hidden.bs.modal", async () => {
                await this.setState({
                    showItemsModal: false,
                    itemsResults: [],
                    itemsPageTotal: 0
                });
            });
        }

        enableSpinner(false);
    }

    refreshItems = async (item, totalRows) => {
        this.setState({
            items: item,
            pageTotal: totalRows
        });
    }

    openSelectWarehouse = async (index) => {
        const { enableSpinner, model } = this.props;

        enableSpinner(true);
        let getAlmacenResponse = []
        if (model.ObjectType === '1470000065') { getAlmacenResponse = model.InventoryCountingLines[index].WarehousesStocks; }
        else if (model.ObjectType === '10000071') { getAlmacenResponse = model.InventoryPostingLines[index].WarehousesStocks; }
        await this.setState({
            showWarehouseModal: true,
            warehouses: getAlmacenResponse,
            itemToUpdate: index,
        });
        $('#almacenDocumentsModal').modal('show');
        $("#almacenDocumentsModal").on("hidden.bs.modal", async () => {
            await this.setState({
                showWarehouseModal: false,
                warehouses: [],
                itemToUpdate: -1,
            });
        });
        enableSpinner(false);
    }

    openSelectBin = async (index) => {
        const { enableSpinner, model, locationsList } = this.props;

        enableSpinner(true);
        const getBinsResponse = await locationsList.find(({ WhsCode }) => WhsCode === model.InventoryCountingLines[index].WarehouseCode)?.data || [];
        await this.setState({
            showBinModal: true,
            binsResults: getBinsResponse,
            itemToUpdate: index });

        $("#selectBinModal").modal("show");
        $("#selectBinModal").on("hidden.bs.modal", async () => {
            await this.setState({
                showBinModal: false,
                binsResults: [],
                itemToUpdate: -1,
            });
        });
        enableSpinner(false);
    }

    openMultipleCountersModal = async (type = -1, title= "", array = []) => {
        let auxArray = Array.from(array); // Romper relación de memoria

        await this.setState({
            showMultipleCountersModal: true,
            multipleCounters: auxArray,
            selectionType: type,
            multipleCountersType: title,
        });
        $("#multipleCountersModal").modal("show");
        $("#multipleCountersModal").on("hidden.bs.modal", async () => {
            await this.setState({
                showMultipleCountersModal: false,
                multipleCounters: [],
                selectionType: -1,
                multipleCountersType: "",
            });
        });
    }
    //#endregion

    //#region RENDER
    renderTitleModal = () => {
        const { action, model } = this.props;

        let complemento = "";

        let authorized = model.isDocumentWithAuthorization;

        if (authorized) { complemento = ""; }

        const objType = (model.ObjectType || -1).toString();

        switch (objType) {
            case '1470000065':
                return `${action === 1 ? 'Nuevo' : 'Detalle de'} Recuento de Inventario ${complemento}`;
            case '10000071':
                return `${action === 1 ? 'Nuevo' : 'Detalle de'} Contabilización de Stocks ${complemento}`;
            default:
        }

        return "";
    }

    renderModalHeader = (ObjectType) => {
        switch (ObjectType) {
            case '1470000065':
                return this.renderInvCountingHeader();
            case '10000071':
                return this.renderInvPostingHeader();
        }
    }

    renderModalBody = (ObjectType) => {
        switch (ObjectType) {
            case '1470000065':
                return this.renderInvCountingBody();
            case '10000071':
                return this.renderInvPostingBody();
        }
    }

    renderModalFooter = (ObjectType) => {
        switch (ObjectType) {
            case '1470000065':
                return this.renderInvCountingFooter();
            case '10000071':
                return this.renderInvPostingFooter();
        }
    }

    //#region InventoryCounting
    renderInvCountingHeader = () => {
        const { model, action } = this.props;
        const { editMode } = this.state;

        return (
            <div className="row mt-2">
                {/*Primera columna*/}
                <div className="col-12 col-lg-6">
                    {/*Fecha y Hora*/}
                    <div className="row">
                        {/*Fecha*/}
                        <div className="col-12 col-sm-7 col-lg-12 col-xl-7">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="lblCountDate">
                                        <span className="d-none d-xl-inline">F. de recuento</span>
                                        <span className="d-inline d-xl-none">F. recuento</span>
                                    </span>
                                </div>
                                <input
                                    type="date"
                                    id="inputCountDate"
                                    className="form-control"
                                    disabled={action === 2}
                                    value={model.CountDate || ""}
                                    onChange={(ev) => this.changeStandardField("CountDate", ev.target.value)} />
                            </div>
                        </div>

                        <div className="col-12 pl-sm-0 col-sm-5 col-lg-12 pl-lg-3 col-xl-5 pl-xl-0">
                            {/*Hora*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="lblTime">Hora</span>
                                </div>
                                <input
                                    type="time"
                                    id="inputTime"
                                    className="form-control"
                                    disabled={action === 2}
                                    value={model.CountTime || ""}
                                    onChange={(ev) => this.changeStandardField("CountTime", ev.target.value)} />
                            </div>
                        </div>
                    </div>

                    {/*Tipo de contabilización*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="lblCountType">
                                <span className="d-none d-xl-inline">Tipo de contabilización</span>
                                <span className="d-inline d-xl-none">Tipo contab.</span>
                            </span>
                        </div>
                        <select
                            id='inputCountType'
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.CountingType || "1"}
                            onChange={(ev) => this.changeStandardField("CountingType", ev.target.value)}>
                            <option value="1">Encargado de recuento simple</option>
                            <option value="2">Encargado de recuento multiple</option>
                        </select>
                    </div>

                    {/*Encargado de recuento*/}
                    {Number(model.CountingType) !== 2 ?
                        /*Encargado de recuento (Simple)*/
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Encargado</span>
                            </div>
                            <select
                                id='inputCountType'
                                className="form-control"
                                disabled={action === 2 && !editMode}
                                value={model.SingleCounterType || "12"}
                                onChange={(ev) => this.changeStandardField("SingleCounterType", ev.target.value)}>
                                <option value="12">Usuario</option>
                                <option value="171">Empleado</option>
                            </select>
                            <input
                                type="text"
                                className="form-control"
                                disabled
                                value={model.SingleCounterName || ""} />
                            {(action === 1 || (action === 2 && editMode)) && // Solo si se esta creando o editando un documento
                                <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={() => this.openSelectCounter(model.SingleCounterType)}>
                                    <i className="fas fa-user fa-lg" />
                                </button>
                            }
                        </div>
                        :
                        /*Encargado de recuento (Multiple)*/
                        <>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                        <span className="d-none d-xl-inline">Encargados de recuento individual</span>
                                        <span className="d-inline d-xl-none">Encarg. individual</span>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control text-right"
                                    disabled
                                    value={model.IndividualCountersQty || 0} />
                                    
                                    <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={() => this.openMultipleCountersModal(1, "Individual", model.IndividualCounters)}>
                                        <i className="fas fa-user fa-lg" />
                                    </button>
                            </div>

                            {/* <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Encargados de recuento por equipo</span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control text-right"
                                    disabled
                                    value={model.TeamCountersQty || 0} />
                                <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={() => this.openMultipleCountersModal(2, "por Equipo", model.TeamCounters)}>
                                    <i className="fas fa-user fa-lg" />
                                </button>
                            </div> */}
                        </>
                    }
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-lg-6">
                    {/*Serie y No*/}
                    <div className="row">
                        {/*Fecha*/}
                        <div className="col-7">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                                </div>
                                <input
                                    type="text"
                                    id="txtDocumentDate"
                                    className="form-control"
                                    disabled
                                    value={model.SeriesName || ''} />
                                {action === 1 && (
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={this.openSeries}>
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                )}
                            </div>
                        </div>

                        {/*Hora*/}
                        <div className="pl-0 col-5">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                                </div>
                                <input
                                    type="text"
                                    className=" form-control"
                                    id="txtDocumentDate"
                                    disabled
                                    value={model.DocumentNumber || ''} />
                            </div>
                        </div>
                    </div>
                    {/**/}
                    {/**/}
                    {/*Referencia*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia 2</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtDocumentDate"
                            disabled={action === 2 && !editMode}
                            value={model.Reference2 || ''}
                            onChange={(ev) => this.changeStandardField("Reference2", ev.target.value)} />
                    </div>
                </div>
            </div>
        );
    }

    renderInvCountingBody = () => {
        const { model, action } = this.props;
        const { editMode, itemSearch } = this.state;

        return (
            <div className="mt-3">
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                    </div>
                </nav>
                <div className="tab-content border border-top-0 rounded-bottom pt-1">
                    {/* CONTENIDO */}
                    <div
                        className="w-100 table-scroll tab-pane fade active show pt-0"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 1000 }}>
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                            <thead className="table-header-yellow">
                                <tr className="sticky-header" style={{ textAlign: "center", backgroundColor: '#d2ab24' }}>
                                    <td className="sticky-column p-2" style={{ backgroundColor: '#d2ab24' }}> # </td>
                                    <td> Artículo </td>
                                    <td> Descripción </td>
                                    <td> Fijar </td>
                                    <td> Almacén </td>
                                    {/* <td> Ubicación </td> */}
                                    <td> Cantidad en almacén </td>
                                    <td> Contado </td>
                                    {Number(model.CountingType) === 1 ? 
                                        <td> Cantidad contada </td>
                                        :
                                        model.IndividualCounters.map((counter, index) =>  <td key={`counter-${index}`}> Cantidad contada ({counter.CounterName}) </td> )
                                    }
                                    <td> Desviación </td>
                                    <td> Desviación (%) </td>
                                    {/* Acción Eliminar */}
                                    {action === 1 && <td className="sticky-columns" style={{ backgroundColor: '#d2ab24' }} />}
                                </tr>
                            </thead>

                            <tbody>
                                {model.InventoryCountingLines.map((inventoryLine, index) => 
                                    <tr
                                        style={{
                                            color: Number(inventoryLine.Variance) !== 0 ? 'red': 'black',
                                            backgroundColor: inventoryLine.LineStatus === 'C' ? 'rgb(210,210,210)' : 'transparent'
                                        }}
                                        key={`invLine-${index}`}>

                                        {/* Número de linea */}
                                        <td className="sticky-column p-2" style={{ backgroundColor: inventoryLine.LineStatus === 'C' ? 'rgb(210,210,210)' : '#FFF', minWidth: 20 }}> {index + 1} </td>
                                        {/* Artículos (ItemCode)*/}
                                        <td> {inventoryLine.ItemCode} </td>
                                        {/* Descripcion (ItemDescription)*/}
                                        <td> {inventoryLine.ItemDescription} </td>
                                        {/* Fijar (Freeze)*/}
                                        <td className="text-center">
                                            <input
                                                type="checkbox"
                                                disabled={action === 2 && !editMode}
                                                checked={inventoryLine.Freeze === "Y"}
                                                onChange={() => this.changeCheckboxStatus(index, "Freeze", !(inventoryLine.Freeze === "Y"))} />
                                        </td>
                                        {/* Almacén (WarehouseCode)*/}
                                        <td className="text-center" style={{ minWidth: 150 }}>
                                            {(action === 2 && !editMode) ?
                                                inventoryLine.WarehouseCode
                                                :
                                                <div className='input-group'>
                                                    <input
                                                        type="text"
                                                        placeholder="Almacén"
                                                        className="form-control text-left"
                                                        onKeyDown={({ key }) => { if (key === 'Enter') { this.openSelectWarehouse(index); } }}
                                                        value={inventoryLine.WarehouseCode}
                                                        onChange={(ev) => this.changeStandardFieldLine("WarehouseCode", index, ev.target.value)}
                                                        onBlur={() => this.validateWarehouse(index, inventoryLine.WarehouseCode)}/>
                                                    <div className="input-group-append">
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                color: '#EABF28',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                                border: "1px solid #ced4da",
                                                                zIndex: 0,
                                                            }}
                                                            className="btn btn-outline-secondary"
                                                            onClick={() => this.openSelectWarehouse(index)}>
                                                            <i className="fa fa-list" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                        </td>
                                        {/* Ubicación (BinCode)*/}
                                        {/* <td style={{ minWidth: 300 }}>
                                            {(action === 2 && !editMode) ?
                                                inventoryLine.BinCode
                                                :
                                                <div className='input-group'>
                                                    <input
                                                        type="text"
                                                        placeholder="Ubicación"
                                                        className="form-control"
                                                        onKeyDown={({ key }) => { if (key === 'Enter') { this.openSelectBin(index); } }}
                                                        disabled={!inventoryLine.UseLocations}
                                                        value={inventoryLine.BinCode}
                                                        onChange={(ev) => this.changeStandardFieldLine("BinCode", index, ev.target.value)} />
                                                    {inventoryLine.UseLocations &&
                                                        <div className="input-group-append">
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                    border: "1px solid #ced4da",
                                                                    zIndex: 0,
                                                                }}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.openSelectBin(index)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </td> */}
                                        {/* Cantidad en almacén (InWarehouseQuantity)*/}
                                        <td className="text-right"> {inventoryLine.InWarehouseQuantity} </td>
                                        {/* Contado (Counted)*/}
                                        <td className="text-center">
                                            <input
                                                type="checkbox"
                                                disabled={action === 2 && !editMode}
                                                checked={inventoryLine.Counted === "Y"}
                                                onChange={() => this.changeCheckboxStatus(index, "Counted", !(inventoryLine.Counted === "Y"))} />
                                        </td>
                                        {/* Cantidad contada (CountedQuantity)*/}
                                        {Number(model.CountingType) === 1 ? //Recuento simple
                                            <td className="text-right">
                                                {(action === 2 && !editMode) ?
                                                    inventoryLine.CountedQuantity
                                                    :
                                                    <input
                                                        type="text"
                                                        id="inputCountedQuantity"
                                                        className="form-control text-right"
                                                        autoComplete="off"
                                                        disabled={inventoryLine.UseLocations && (!inventoryLine.BinEntry || inventoryLine.BinEntry === "")}
                                                        value={inventoryLine.CountedQuantity || ''}
                                                        onChange={(ev) => this.changeCountedQty(index, ev.target.value)}
                                                        onBlur={() => this.validateCountedQty(index, inventoryLine.CountedQuantity)} />
                                                }
                                            </td>
                                            : // Recuento multiple
                                            inventoryLine.IndividualCounters.map((counterLine, counterIndex) =>
                                                <td className="text-right" key={`countLine-${index}`}>
                                                    {(action === 2 && !editMode) ?
                                                        counterLine.CountedQuantity
                                                        :
                                                        <input
                                                            type="text"
                                                            id="inputCountedQuantity"
                                                            className="form-control text-right"
                                                            autoComplete="off"
                                                            disabled={inventoryLine.UseLocations && (!inventoryLine.BinEntry || inventoryLine.BinEntry === "")}
                                                            value={counterLine.CountedQuantity || ''}
                                                            onChange={(ev) => this.changeMultipleCountedQty(index, counterIndex, ev.target.value)}
                                                            onBlur={() => this.validateMultipleCountedQty(index, counterIndex, counterLine.CountedQuantity)} />
                                                    }
                                                </td>
                                            )
                                        }
                                        {/* Desviación (Variance)*/}
                                        <td className="text-right"> {inventoryLine.Variance} </td>
                                        {/* Desviación % (VariancePercentage)*/}
                                        <td className="text-right"> {inventoryLine.VariancePercentage} % </td>
                                        {/* Acción Eliminar */}
                                        {action === 1 &&
                                            <td className="sticky-columns cell-actions">
                                                <button
                                                    type="button"
                                                    className="btn icon-btn"
                                                    onClick={() => this.deleteItem(index)}>
                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                </button>
                                            </td>
                                        }
                                    </tr>
                                )}

                                <tr>
                                    <td colSpan={3} className="sticky-column p-2"
                                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                        {(action === 1 || (action === 2 && editMode)) && // Solo si se esta creando o editando un documento
                                            <div className='input-group'>
                                                <input
                                                    id='itemDocumentSearch'
                                                    className="form-control"
                                                    type="text"
                                                    placeholder="Artículo"
                                                    autocomplete="off"
                                                    onKeyDown={(event) => this.ItemCodeInteractions(event)}
                                                    value={itemSearch || ''}
                                                    onChange={event => this.changeSearchItem(event.target.value)}
                                                    onBlur={() => this.setState({ showItemsSuggestion: false })} />
                                                <div className="input-group-append" >
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: 'green',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                            border: "1px solid #ced4da"
                                                        }}
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => this.openSelectItem(itemSearch)}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    renderInvCountingFooter = () => {
        const { model, action } = this.props;
        const { editMode } = this.state;

        return (
            <div className="row mt-4">
                <div className="col-12 col-md-6">
                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className="form-control styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={250}
                            disabled={action === 2 && !editMode}
                            value={model.Remarks || ''}
                            onChange={(ev) => this.changeStandardField("Remarks", ev.target.value)} />
                    </div>
                </div>
                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                </div>
            </div>
        );
    }
    //#endregion
    
    //#region InventoryPosting
    renderInvPostingHeader = () => {
        const { model, priceListArray } = this.props;
        const { editMode, action } = this.state;

        return (
            <div className="row mt-2">
                {/*Primera columna*/}
                <div className="col-12 col-lg-6">
                    {/*Fecha de  contabilización*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="lblPostingDate">
                                <span className="d-none d-xl-inline">F. de contabilización</span>
                                <span className="d-inline d-xl-none">F. contab.</span>
                            </span>
                        </div>
                        <input
                            type="date"
                            id="inputPostingDate"
                            className="form-control"
                            disabled={action === 2}
                            value={model.PostingDate || ""}
                            onChange={(ev) => this.changeStandardField("PostingDate", ev.target.value)} />
                    </div>

                    {/*Fecha y Hora de recuento*/}
                    <div className="row">
                        {/*Fecha*/}
                        <div className="col-12 col-sm-7 col-lg-12 col-xl-7">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="lblCountDate">
                                        <span className="d-none d-xl-inline">F. de recuento</span>
                                        <span className="d-inline d-xl-none">F. recuento</span>
                                    </span>
                                </div>
                                <input
                                    type="date"
                                    id="inputCountDate"
                                    className="form-control"
                                    disabled={action === 2}
                                    value={model.CountDate || ""}
                                    onChange={(ev) => this.changeStandardField("CountDate", ev.target.value)} />
                            </div>
                        </div>

                        <div className="col-12 pl-sm-0 col-sm-5 col-lg-12 pl-lg-3 col-xl-5 pl-xl-0">
                            {/*Hora*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="lblTime">Hora</span>
                                </div>
                                <input
                                    type="time"
                                    id="inputTime"
                                    className="form-control"
                                    disabled={action === 2}
                                    value={model.CountTime || ""}
                                    onChange={(ev) => this.changeStandardField("CountTime", ev.target.value)} />
                            </div>
                        </div>
                    </div>

                    {/*Fuente de Precio*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="lblPriceSource">
                                <span className="d-none d-xl-inline">Fuente de precio</span>
                                <span className="d-inline d-xl-none">Fuente precio</span>
                            </span>
                        </div>
                        <select
                            id='inputPriceSource'
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.PriceSource || "1"}
                            onChange={(ev) => this.changeStandardField("PriceSource", ev.target.value)}>
                            <option value="1">Por Precio de Lista</option>
                            <option value="2">Último Precio Determinado</option>
                            <option value="3">Costo del Artículo</option>
                        </select>
                    </div>


                    {/*Lista de Precio*/}
                    {Number(model.PriceSource || 0) === 1 &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="lblPriceList">
                                    <span className="d-none d-xl-inline">Lista de precio</span>
                                    <span className="d-inline d-xl-none">Precio</span>
                                </span>
                            </div>
                            <select
                                id='inputPriceList'
                                className="form-control"
                                disabled={action === 2 && !editMode}
                                value={model.PriceList || ""}
                                onChange={(ev) => this.changeStandardField("PriceList", ev.target.value)}>
                                {Array.isArray(priceListArray) ? priceListArray.map(({ ListNum, ListName }, index) => <option value={ListNum} key={`priceList-${index}`}> {ListName} </option>) : ''}
                                <option value={-1}>Último precio de compra</option>
                            </select>
                        </div>
                    }
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-lg-6">
                    {/*Serie y No*/}
                    <div className="row">
                        {/*Fecha*/}
                        <div className="col-7">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                                </div>
                                <input
                                    type="text"
                                    id="txtDocumentDate"
                                    className="form-control"
                                    disabled
                                    value={model.SeriesName || ''} />
                                {action === 1 && (
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={this.openSeries}>
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                )}
                            </div>
                        </div>

                        {/*Hora*/}
                        <div className="pl-0 col-5">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                                </div>
                                <input
                                    type="text"
                                    className=" form-control"
                                    id="txtDocumentDate"
                                    disabled
                                    value={model.DocumentNumber || ''} />
                            </div>
                        </div>
                    </div>

                    {/*Referencia*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia 2</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtDocumentDate"
                            disabled={action === 2 && !editMode}
                            value={model.Reference2 || ''}
                            onChange={(ev) => this.changeStandardField("Reference2", ev.target.value)} />
                    </div>
                </div>
            </div>
        );
    }

    renderInvPostingBody = () => {
        const { model } = this.props;
        const { editMode, action, itemSearch } = this.state;

        return (
            <div className="mt-3">
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                    </div>
                </nav>
                <div className="tab-content border border-top-0 rounded-bottom pt-1">
                    {/* CONTENIDO */}
                    <div
                        className="w-100 tab-pane fade active show pt-0"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 1000, overflowY: 'auto' }}>
                    <div className="table-responsive">
                        <table
                            id="dataTableDocuments"
                            className="display w-100"
                            style={{ marginBottom: 40 }}>
                            <thead className="table-header-yellow">
                                <tr className="sticky-header" style={{ textAlign: "center", backgroundColor: '#d2ab24' }}>
                                    <td className="sticky-column p-2" style={{ backgroundColor: '#d2ab24' }}> # </td>
                                    <td> Artículo </td>
                                    <td> Descripción </td>
                                    <td> Almacén </td>
                                    {/* <td> Ubicación </td> */}
                                    <td> Cantidad en almacén </td>
                                    <td> Cantidad contada </td>
                                    <td> Desviación </td>
                                    <td> Desviación (%) </td>
                                    <td> Precio </td>
                                    <td> Total </td>
                                    {/* Acción Eliminar */}
                                    {action === 1 && <td className="sticky-columns" style={{ backgroundColor: '#d2ab24' }} />}
                                </tr>
                            </thead>

                            <tbody>
                                {model.InventoryPostingLines.map((inventoryLine, index) => 
                                    <tr style={{ color: Number(inventoryLine.Variance) < 0 ? 'red': 'black' }} key={`invLine-${index}`}>
                                        {/* Número de linea */}
                                        <td className="sticky-column p-2" style={{ backgroundColor: '#FFF' }}> {index + 1} </td>
                                        {/* Artículos (ItemCode)*/}
                                        <td className="p-2"> {inventoryLine.ItemCode} </td>
                                        {/* Descripcion (ItemDescription)*/}
                                        <td className="p-2"> {inventoryLine.ItemDescription} </td>
                                        {/* Almacén (WarehouseCode)*/}
                                        <td className="text-center p-2" style={{ minWidth: 150 }}>
                                            {(action === 2) ?
                                                inventoryLine.WarehouseCode
                                                :
                                                <div className='input-group'>
                                                    <input
                                                        type="text"
                                                        placeholder="Almacén"
                                                        className="form-control text-left"
                                                        onKeyDown={({ key }) => { if (key === 'Enter') { this.openSelectWarehouse(index); } }}
                                                        value={inventoryLine.WarehouseCode}
                                                        onChange={(ev) => this.changeStandardFieldLine("WarehouseCode", index, ev.target.value)}
                                                        onBlur={() => this.validateWarehouse(index, inventoryLine.WarehouseCode)}/>
                                                    <div className="input-group-append">
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                color: '#EABF28',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                                border: "1px solid #ced4da",
                                                                zIndex: 0,
                                                            }}
                                                            className="btn btn-outline-secondary"
                                                            onClick={() => this.openSelectWarehouse(index)}>
                                                            <i className="fa fa-list" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                        </td>
                                        {/* Cantidad en almacén (InWarehouseQuantity)*/}
                                        <td className="text-right p-2"> {FORMAT_NUMBER(inventoryLine.InWarehouseQuantity, 3)} </td>
                                        {/* Cantidad contada (CountedQuantity)*/}
                                        <td className="text-right p-2" style={{ minWidth: 150 }}>
                                            {(action === 2) ?
                                                FORMAT_NUMBER(inventoryLine.CountedQuantity, 3)
                                                :
                                                <input
                                                    type="text"
                                                    id="inputCountedQuantity"
                                                    className="form-control text-right"
                                                    autoComplete="off"
                                                    value={inventoryLine.CountedQuantity || ''}
                                                    onChange={(ev) => this.changeCountedQty(index, ev.target.value)}
                                                    onBlur={() => this.validateCountedQty(index, inventoryLine.CountedQuantity)} />
                                            }
                                        </td>
                                        {/* Desviación (Variance)*/}
                                        <td className="text-right p-2" style={{ minWidth: 150 }}> {FORMAT_NUMBER(inventoryLine.Variance, 3)} </td>
                                        {/* Desviación % (VariancePercentage)*/}
                                        <td className="text-right p-2"> {FORMAT_NUMBER(inventoryLine.VariancePercentage, 4)} % </td>
                                        {/* Precio */}
                                        <td className="text-right p-2"> {FORMAT_NUMBER(inventoryLine.Price)} </td>
                                        {/* Total */}
                                        <td className="text-right p-2"> {FORMAT_NUMBER(inventoryLine.Total)} </td>
                                        {/* Acción Eliminar */}
                                        {action === 1 &&
                                            <td className="sticky-columns cell-actions p-2">
                                                <button
                                                    type="button"
                                                    className="btn icon-btn"
                                                    onClick={() => this.deleteItem(index)}>
                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                </button>
                                            </td>
                                        }
                                    </tr>
                                )}

                                <tr>
                                    <td colSpan={3} className="sticky-column p-2"
                                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                        {(action === 1 || (action === 2 && editMode)) && // Solo si se esta creando o editando un documento
                                            <div className='input-group'>
                                                <input
                                                    id='itemDocumentSearch'
                                                    className="form-control"
                                                    type="text"
                                                    placeholder="Artículo"
                                                    autocomplete="off"
                                                    onKeyDown={(event) => this.ItemCodeInteractions(event)}
                                                    value={itemSearch || ''}
                                                    onChange={event => this.changeSearchItem(event.target.value)}
                                                    onBlur={() => this.setState({ showItemsSuggestion: false })} />
                                                <div className="input-group-append" >
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: 'green',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                            border: "1px solid #ced4da"
                                                        }}
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => this.openSelectItem(itemSearch)}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
        );
    }

    renderInvPostingFooter = () => {
        const { model } = this.props;
        const { editMode, action } = this.state;

        return (
            <div className="row mt-4">
                {/*Primera columna*/}
                <div className="col-12 col-md-6">
                    {/*Comentarios*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="lblRemarks"> Comentarios </span>
                        </div>
                        <textarea
                            className="form-control styleTextarea"
                            id="inputRemarks"
                            placeholder="250 caracteres máximo"
                            maxLength={250}
                            disabled={action === 2 && !editMode}
                            value={model.Remarks || ''}
                            onChange={(ev) => this.changeStandardField("Remarks", ev.target.value)} />
                    </div>
                    {/*Entrada en el diario*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="lblJournalRemark">
                                <span className="d-none d-xl-inline">Entrada en el diario</span>
                                <span className="d-inline d-xl-none">Entrada diario</span>
                            </span>
                        </div>
                        <input
                            className="form-control"
                            id="inputJournalRemark"
                            disabled={action === 2 && !editMode}
                            value={model.JournalRemark || ''}
                            onChange={(ev) => this.changeStandardField("JournalRemark", ev.target.value)} />
                    </div>
                </div>
                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                </div>
            </div>
        );
    }
    //#endregion

    render() {
        const {
            view,
            model
        } = this.props;

        const {
            //#region Variables de control
            action,
            editMode,
            itemToUpdate,
            //#endregion

            //#region Modales de selección
            showItemsModal,
            itemsPageTotal,
            itemsResults,

            showBinModal,
            binsResults,

            showMultipleCountersModal,
            multipleCounters,
            multipleCountersType,

            showCountersModal,
            countersResults,
            countersModalHeaders,

            showWarehouseModal,
            warehouses,
            //#endregion

            //#region Lista de sugerencias
            showItemsSuggestion,
            itemsSuggestions,
            indexItemCode,
            showUsersSuggestion,
            usersSuggestions,
            showEmployeesSuggestion,
            employeesSuggestions,
            //#endregion
            series,
        } = this.state;

        return (
            <>
                <div
                    id="InventoryCountingCreateModal"
                    className="modal fade bd-example-modal-xl modal-open scroll"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false">
                    <div
                        id="InventoryCountingCreateModal-content"
                        className="modal-dialog modal-xl modal-open modalOrder"
                        role="document">
                        <div className="modal-content">
                            <div className="modal-header text-white"
                                style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">
                                    {this.renderTitleModal()}
                                </h4>
                                <button type="button" className="close" onClick={() => $("#InventoryCountingCreateModal").modal("hide")} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="container-fluid">
                                {this.renderModalHeader(model.ObjectType)}
                                {this.renderModalBody(model.ObjectType)}
                                {this.renderModalFooter(model.ObjectType)}
                            </div>
                            </div>
                            <div className="modal-footer">
                                {Number(action) === 1 &&
                                    <button type="button" className="btn btn-info text-white" style={{ position: "absolute", left: "1rem" }} onClick={this.copyQuantities}>
                                        Copiar cantidades
                                    </button>
                                }
                                {model.ObjectType === '1470000065' ? (Number(action) === 2 && !editMode && (model.InventoryCountingLines.find(({ LineStatus, Variance }) => LineStatus === 'O' && Number(Variance))) &&
                                    (<button className="btn botonCorrect" onClick={this.selectTo}> Copiar a Contabilización de Stocks </button>)) : ''
                                }

                                {/* {Number(action) === 1 && writeAccess &&
                                    (model.Items.length === 0) &&
                                    (
                                        <label className="btn botonCorrect text-white">
                                            <select name="select" className="btn botonCorrect text-white" value={'--'}
                                                onChange={this.selectOf}>
                                                <option value="--">Copiar de ...</option>
                                            </select>

                                        </label>
                                    )
                                } */}

                                {Number(action) === 1 &&
                                    <button className="btn botonCorrect" onClick={this.validateModel}> Crear </button>
                                }

                                {(Number(action) === 2 && editMode) &&
                                    <button className="btn botonCorrect" onClick={this.acceptEditMode}> Guardar </button>
                                }

                                {(Number(action) === 1 || (Number(action) === 2 && editMode)) &&
                                    <button className="btn botonCerrar text-white" onClick={() => $("#InventoryCountingCreateModal").modal("hide")}>
                                        Cancelar
                                    </button>
                                }

                                {Number(action) === 2 &&
                                    <button className="btn botonCerrar text-white" onClick={() => $("#InventoryCountingCreateModal").modal("hide")}> Cerrar </button>
                                }

                            </div>
                        </div>
                    </div>
                </div>

                { // region Modales de selección
                    <>                    
                        {showItemsModal && // Artículos
                            <ItemsCreateModal
                                data={itemsResults}
                                totalPage={itemsPageTotal}
                                newOrderModel={{ CardCode: null }}
                                mainView={"transfers"}
                                selectItems={this.selectItems}
                                cleanData={() => this.setState({ itemsResults: [], itemsPageTotal: 0 })}
                                refreshItems={this.refreshItems} />
                        }

                        {showWarehouseModal && // Almacenes
                            <AlmacenModal
                                data={warehouses}
                                view={view}
                                itemSelected={itemToUpdate}
                                selectAlmacen={this.selectWarehouse}
                                cleanData={() => this.setState({ warehouses: [], itemSelected: '' })} />
                        }

                        {showBinModal && // Ubicaciones
                            <StandardSelectModal
                                id="selectBinModal"
                                title="Selección de ubicación"
                                data={binsResults}
                                cleanData={() => this.setState({ binsResults: [], itemToUpdate: -1, })}
                                selectAction={this.selectBinCode}

                                headers={binHeaders}/>
                        }

                        {showMultipleCountersModal && // Encargados de recuento multiple
                            <MultipleCountersModal
                                counters={multipleCounters}
                                type={multipleCountersType}
                                writeMode={!(action === 2 && !editMode)}
                                openSelectCounter={this.openSelectCounter}
                                removeCounter={this.removeCounter}
                                saveCounters={this.saveCounters}/>
                        }

                        {showCountersModal && // Encargado de recuento
                            <StandardSelectModal
                                id="selectSingleCounterModal"
                                title={"Seleccionar Encargado de Recuento"}
                                data={countersResults}
                                cleanData={() => this.setState({ countersResults: [] })}
                                selectAction={this.selectCounter}

                                headers={countersModalHeaders}
                                actPos="start" />
                        }

                        <SeriesCreateModal
                            data={series}
                            selectSerie={this.selectSeries}
                            cleanData={() => this.setState({ series: [] })} />
                    </>
                }
            </>
        );
    }
    //#endregion
}

export default InventoryCountingCreateModal;